import { z } from "zod";

const dashboardPanelSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const profileDashboardPanelSchema = z.object({
  dashboardPanel: dashboardPanelSchema
    .nullable()
    .refine(Boolean, "Selecione um dashboard"),
});

export type TProfileDashboardPanelForm = z.infer<
  typeof profileDashboardPanelSchema
>;
